export default {
  assets: {
    /*
    [id] : {
      id: string,
      name: string,
      sessionHash: string,
      status: string,
    }
    */
  },
};
